import { LayaEnv } from "../../LayaEnv";
import { UIEvent } from "./UIEvent";
export class ControllerRef {
    constructor(target, name) {
        if (arguments.length == 2) {
            this._target = target;
            this._name = name || "";
        }
        else {
            this._target = target.owner;
            this._name = target.name;
        }
        this._inst = null;
    }
    get target() {
        return this._target;
    }
    get name() {
        return this._name;
    }
    get inst() {
        return this._inst;
    }
    get selectedIndex() {
        return this._inst ? this._inst.selectedIndex : -1;
    }
    set selectedIndex(value) {
        if (this._inst)
            this._inst.selectedIndex = value;
    }
    get selectedPage() {
        return this._inst ? this._inst.selectedPage : "";
    }
    set selectedPage(value) {
        if (this._inst)
            this._inst.selectedPage = value;
    }
    get previousIndex() {
        return this._inst ? this._inst.selectedIndex : 0;
    }
    set oppositeIndex(value) {
        if (this._inst)
            this._inst.oppositeIndex = value;
    }
    release() {
        if (this._inited) {
            this._inited = false;
            this._target.off(UIEvent.ControllersChanged, this, this._check);
            if (!LayaEnv.isPlaying)
                this._target.off(UIEvent.InstanceReload, this, this._reload);
            if (this._inst) {
                this._inst._refs.delete(this);
                this._inst = null;
            }
        }
    }
    validate() {
        if (!this._inited) {
            this._inited = true;
            this._target.on(UIEvent.ControllersChanged, this, this._check);
            if (!LayaEnv.isPlaying)
                this._target.on(UIEvent.InstanceReload, this, this._reload);
            this._check(true);
        }
    }
    _reload(newIns) {
        this._target = newIns;
        this._check();
    }
    _check(noEmit) {
        let c = this._target.getController(this._name);
        if (c != this._inst) {
            if (this._inst)
                this._inst._refs.delete(this);
            this._inst = c;
            if (c)
                this._inst._refs.add(this);
            if (!noEmit)
                this.onChanged(c);
        }
    }
}
